import { TrainingInsightFragment } from 'generated/resources/graphql'
import compact from 'lodash/compact'

export const useTrainingHoursEmployee = (insights: TrainingInsightFragment) => {
  const trainingHoursEmployee = compact(
    insights.trainingHoursPerEmployee
      ? insights.trainingHoursPerEmployee.map((value) => {
          const employee = insights.employees.find((e) => e.id === value.employeeId)
          if (!employee) return

          return { label: employee.fullName, value: value.totalSessionsHours }
        })
      : []
  )

  return { trainingHoursEmployee }
}
